import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface ClinicUserRolePermission {
  clinic_user_role_permission_id: number
  user_role_id: number
  module: string
  allowed_action: string[]
  created_at: string
  updated_at: string
}

interface ClinicUserRolePermissionListResponse {
  success: boolean
  data: ClinicUserRolePermission[]
  error?: {
    code: string
    message: string
  }
}

export function useClinicUserRolePermissionByRoleId(roleId: number, enabled: boolean = true) {
  const { token } = useAuth()

  const { data, error, isLoading, mutate } = useGet<ClinicUserRolePermissionListResponse>(
    token && enabled ? `/api/clinic-user-role-permissions/role/${roleId}` : null,
    undefined,
    token ?? '',
    undefined,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 0,
      shouldRetryOnError: false,
    },
  )

  return {
    permissions: data?.data ?? [],
    isLoading: enabled ? isLoading : false,
    isError: enabled ? error : null,
    mutate,
  }
}
